import React, { Component } from "react";
import styles from "./index.module.scss";
import axios from "@/util/axios";
import { api } from "@/routes/api";
import FileModal from "./components/FileModal";
const { getReportList } = api;
let timer = null;

class Index extends Component {
  state = {
    reportList: "",
    page: 1,
    limit: 30,
    open: false,
    input: ''
  };

  componentDidMount() {
    this.getReportList();
  }

  getReportList = async (page = this.state.page, limit = this.state.limit, name="") => {
    const res = await axios.post(getReportList, { page, limit, name });
    if (res.code === 0) {
      this.setState({ reportList: res.data.data, ambulance: res.ambulance });
    }
  };

  handleChange = e => {
    const value = e.target.value;
    this.setState({ input: value, isOpen: true, selectedItem: {} });
    if (value) {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => { this.getReportList(null, null, value)}, 500);
    } else {
      this.setState({ reportList: "" });
    }
  };

  //解决iOS字体小于16px自动缩放问题
  handleInputMouseDown = e => {
    e.target.style.fontSize = '16px'; //mouse down时，把字体改为16px，使得iOS不会自动放大页面
  };
  handleInputFocus = e => {
    e.target.style.fontSize = ''; //focus时，把字体恢复为原先的字体
    this.setState({ isOpen: true });
  };

  handleSelectItem = (item,e) => {
    e.stopPropagation();
    this.getReportList();
    this.setState({
      input: item.name,
      selectedItem: item,
      isOpen: false
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  showModal = () => {
    this.setState({ open: true });
  }

  render() {
    const {
      input,
      reportList,
      open,
      ambulance,
      selectedItem,
      isOpen
    } = this.state;
    return (
      <div className="search">
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </div>
        <div className={styles.search_container}>
          <div className={styles.left_container}>
            <img src="/images/productInfo/product_info_1.png" alt="" />
          </div>
          <div className={styles.center_wrapper}>
            <div className={styles.center_container}>
              <div className={styles.search_input}>
                <div className={styles.label}>检测报告查询：</div>
                <div className={styles.input}>
                  <input
                    placeholder="输入产品名称即可查看产品检测报告"
                    onChange={this.handleChange}
                    onMouseDown={this.handleInputMouseDown}
                    onFocus={this.handleInputFocus}
                    value={input}
                    onBlur={() => setTimeout(() => this.setState({ isOpen: false }), 200)}
                  />
                  {reportList && isOpen ? (
                    <div className={styles.search_result_container}>
                      <ul className={styles.search_result}>
                        {reportList.length > 0 ? (
                          reportList.map(item => (
                            <li
                              className={styles.result_item}
                              onClick={(e) => this.handleSelectItem(item,e)}
                              key={item.id}
                            >
                              {item.name}
                            </li>
                          ))
                        ) : (
                          <li>无相关数据</li>
                        )}
                      </ul>
                    </div>
                  ) : null}
                </div>
                <div className={styles.btn}>
                  <button onClick={this.showModal}>查询</button>
                </div>
                <div className={styles.desc_container}>
                  <div className={styles.app_input}>
                    <input 
                      placeholder="输入产品名称即可查看产品检测报告"
                      onChange={this.handleChange}
                      value={input}
                      onFocus={() => this.setState({ isOpen: true })}
                      onBlur={() => setTimeout(() => this.setState({ isOpen: false }), 200)}
                    />
                    <img src="/images/search.png" alt="" onClick={this.showModal} />
                    {reportList && isOpen ? (
                      <div className={styles.app_search_result_container}>
                        <ul className={styles.search_result}>
                          {reportList.length > 0 ? (
                            reportList.map(item => (
                              <li
                                className={styles.result_item}
                                onClick={(e) => this.handleSelectItem(item,e)}
                                key={item.id}
                              >
                                {item.name}
                              </li>
                            ))
                          ) : (
                            <li>无相关数据</li>
                          )}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                  <div className={styles.desc_content}>
                    十年雅集路，是茶美物的设计之路。雅集向来注重产品梯队的建设，截至目前，材质、工艺、设计、包装、服务已成为雅集的五项品牌亮点。秉承公平公正的原则，为让产品能更好地还原茶味，雅集严选测试设备完善、操作流程规范、检测技术成熟的第三方机构合作，不定期对产品材质、工艺进行检测。根据第三方机构的科学解读，雅集不断改进产品，提升用户的使用体验，争取为广大茶友带来更多更好的茶器美物。
                  </div>
                </div>
              </div>
              <div className={styles.search_desc}>
                十年雅集路，是茶美物的设计之路。雅集向来注重产品梯队的建设，截至目前，材质、工艺、设计、包装、服务已成为雅集的五项品牌亮点。秉承公平公正的原则，为让产品能更好地还原茶味，雅集严选测试设备完善、操作流程规范、检测技术成熟的第三方机构合作，不定期对产品材质、工艺进行检测。根据第三方机构的科学解读，雅集不断改进产品，提升用户的使用体验，争取为广大茶友带来更多更好的茶器美物。
              </div>
            </div>
          </div>
          <div className={styles.right_container}>
            <img src="/images/productInfo/product_info_2.png" alt="" />
          </div>
          <div className={styles.clearfix}></div>
        </div>
        <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
        {open ? (
          <FileModal
            style={{ width: 800, height: 500 }}
            open={open}
            handleClose={this.handleClose}
            ambulance={ambulance}
            selectedItem={selectedItem}
          />
        ) : null}
      </div>
    );
  }
}

export default Index;
